import type { ProductPartner } from '@noths/polaris-dev-ts-types';

import type { PlpPreviewProduct } from 'src/services/plpPreview/types';
import type { TrackingProductData } from 'src/tracking/common/products';

export const transformPlpPreviewProductToTrackingProductData = (
  product: PlpPreviewProduct,
): TrackingProductData => ({
  code: product.code,
  freeDomesticDelivery: product.deliveryCost === 0,
  isNew: product.isNew,
  onSale: product.onSale,
  partner: product.partner as ProductPartner,
  price: product.price,
  purchasable: product.purchasable,
  salePercentage: product.salePercentage,
  title: product.title,
});
